module.exports = __webpack_public_path__ + "static/media/ar.cab4b98a.svg";